/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Copy_ButtonInputs */

const en_offline_activation_copy_button = /** @type {(inputs: Offline_Activation_Copy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Code`)
};

const fr_offline_activation_copy_button = /** @type {(inputs: Offline_Activation_Copy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le code`)
};

const de_offline_activation_copy_button = /** @type {(inputs: Offline_Activation_Copy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code kopieren`)
};

const it_offline_activation_copy_button = /** @type {(inputs: Offline_Activation_Copy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia il codice`)
};

const ru_offline_activation_copy_button = /** @type {(inputs: Offline_Activation_Copy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать код`)
};

const es_offline_activation_copy_button = /** @type {(inputs: Offline_Activation_Copy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar código`)
};

const zh_cn2_offline_activation_copy_button = /** @type {(inputs: Offline_Activation_Copy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制代码`)
};

const ja_offline_activation_copy_button = /** @type {(inputs: Offline_Activation_Copy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードをコピー`)
};

const hi_offline_activation_copy_button = /** @type {(inputs: Offline_Activation_Copy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोड कॉपी करें`)
};

const pt_pt2_offline_activation_copy_button = /** @type {(inputs: Offline_Activation_Copy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar código`)
};

/**
* | output |
* | --- |
* | "Copy Code" |
*
* @param {Offline_Activation_Copy_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_copy_button = /** @type {((inputs?: Offline_Activation_Copy_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Copy_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_activation_copy_button(inputs)
	if (locale === "de") return de_offline_activation_copy_button(inputs)
	if (locale === "it") return it_offline_activation_copy_button(inputs)
	if (locale === "ru") return ru_offline_activation_copy_button(inputs)
	if (locale === "es") return es_offline_activation_copy_button(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_activation_copy_button(inputs)
	if (locale === "ja") return ja_offline_activation_copy_button(inputs)
	if (locale === "hi") return hi_offline_activation_copy_button(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_activation_copy_button(inputs)
	return en_offline_activation_copy_button(inputs)
});